import { render, staticRenderFns } from "./loginRecaptcha.vue?vue&type=template&id=0b970ac0&"
import script from "./loginRecaptcha.vue?vue&type=script&lang=js&"
export * from "./loginRecaptcha.vue?vue&type=script&lang=js&"
import style0 from "./loginRecaptcha.vue?vue&type=style&index=0&id=0b970ac0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports